<ng-container *ngIf='!accessDenied'>
    <div *ngIf='!loader' class="w-100 float-left">
        <div class="w-100 float-left v-align relative" *ngIf='mainPage'>
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0">RECORD FORMAT</h5>
                <div style="flex-grow: 1;"></div>
                <button id="add" (click)="uploadFile()" class="btn btn-primary float-right mr-3"> Upload File</button>
                <button id="add" (click)="addNewRecord()" class="btn btn-primary float-right mr-3"> Add Record Format
                </button>
            </div>

        </div>
        <div *ngIf='mainPage' class="main-table table-custom">
            <div class="w-100 float-left p-3 light-bg">
                <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12 float-left p-2 align-v-center">
                    <input class="w-50 float-left form-control" name="searchBox" id="searchBox" #searchBox
                           maxlength="100"
                           placeholder="Keywords" type="text" ng-reflect-maxlength="100" ng-reflect-model=""
                           [(ngModel)]="recordFormatReg">
                    <div>
                        <button id="Search" (click)="searchPRecordFormat()" class="btn btn-primary float-left">Search
                        </button>
                    </div>
                </div>
            </div>

            <div class="w-100 float-left mt-3" *ngIf='recordList && recordList.length'>
                <div class="light-bg w-100 float-left p-2 grid-details">
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Code">
                        <h6 class="mb-lg-0 medium text-truncate"> Code </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Name">
                        <h6 class="mb-lg-0 medium text-truncate"> Name </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Description">
                        <h6 class="mb-lg-0 medium text-truncate"> Description </h6>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center" ngbTooltip="Actions">
                        <h6 class="mb-lg-0 medium text-truncate"> Actions </h6>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left p-md-2 grid-details" *ngFor="let rf of recordList;">

                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{rf.recordFormatCode}}">
                    <h6 class="mb-lg-0 text-truncate"> {{rf.recordFormatCode}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{rf.displayName}}">
                    <h6 class="mb-lg-0 text-truncate"> {{rf.displayName}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{rf.description}}">
                    <h6 class="mb-lg-0 text-truncate"> {{rf.description}} </h6>
                </div>
                <!-- <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                    <h6 class="mb-lg-0" ngbtooltip="Click for more options" ng-reflect-ngb-tooltip="Click for more options">
                        <i class="fa fa-ellipsis-h" [id]="rf.id" (click)=entityOps($event)></i>
                    </h6>
                    <div class="empActions m-t-nsmd" *ngIf="selectedRFId==rf.id?true:false">
                        <i class="fa fa-caret-up caret-up"></i>
                        <ul class="m-0 p-0">
                            <li (click)="clickEdit(rf)">
                                <i class="fa fa-pencil mr-2"></i>Edit
                            </li>
                            <li *ngIf="rf.dataEngineType && rf.dataEngineType == 'DRILL'" (click)="syncRecordFormat(rf)">
                                <i class="fa fa-refresh mr-2"> </i>Sync Cube
                            </li>
                            <li *ngIf="rf.uploadAllowed" (click)="uploadFile('reUpLoad', rf)">
                                <i class="fa fa-upload mr-2"></i>Re Upload
                            </li>
                            <li *ngIf="rf && rf.id && rf.downloadable" (click)="closeActionsMenu($event)">
                                <a class="link" href="{{downloadUrl}}/{{rf.id}}" target="_new"><i
                                        class="fa fa-download mr-2"></i>Download</a>
                            </li>
                            <li (click)="removeRecord(rf)">
                                <i class="fa fa-trash mr-2"></i>Delete
                            </li>
                        </ul>
                    </div>

                </div> -->
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center" [id]="rf.id"
                     (mouseenter)=entityOps($event)
                     (mouseleave)=closeDropDown($event)>
                    <h6 class="mb-lg-0">
                        <i class="fa fa-ellipsis-h"></i>
                    </h6>
                    <div class="empActions m-t-nsmd" style="top:29px" *ngIf="selectedRFId==rf.id?true:false">
                        <i class="fa fa-caret-up caret-up"></i>
                        <ul class="m-0 p-0">
                            <li (click)="clickEdit(rf)">
                                <i class="fa fa-pencil mr-2"></i>Edit
                            </li>
                            <li *ngIf="rf.dataEngineType && rf.dataEngineType == 'DRILL'"
                                (click)="syncRecordFormat(rf)">
                                <i class="fa fa-refresh mr-2"> </i>Sync Cube
                            </li>
                            <li *ngIf="rf.uploadAllowed" (click)="uploadFile('reUpLoad', rf)">
                                <i class="fa fa-upload mr-2"></i>Re Upload
                            </li>
                            <li *ngIf="rf && rf.id && rf.downloadable" (click)="downloadFile(rf)">
                                <!-- <a class="link" href="{{downloadUrl}}/{{rf.id}}" target="_new"><i class="fa fa-download mr-2"></i>Download</a> -->
                                <a class="link"><i class="fa fa-download mr-2"></i>Download</a>
                            </li>
                            <li (click)="removeRecord(rf)">
                                <i class="fa fa-trash mr-2"></i>Delete
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
            <ng-container *ngIf='recordList.length == 0'>
                <div class="w-100 float-left p-4 grid-details" *ngIf="!loader">
                    <p class="text-center m-0 w-100 medium">No Results Found</p>
                </div>
            </ng-container>

            <!-- PAGINATION -->
            <div class="w-100 float-left my-4 light-bg p-3 align-v-center mb-5">
                <h6 class="float-left mb-0 mr-4 text-truncate"> {{startingPage + 1}} - {{endingPage}} of
                    {{totalRecords}}
                    items </h6>
                <div class="float-left ml-2 align-v-center">
                    <label class="m-0 float-left">Show items per page</label>
                    <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="pageSize"
                            (change)="OnPageSizeChanged($event)">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                    </select>
                </div>
                <div style="flex-grow: 1;"></div>
                <ngb-pagination *ngIf='recordList && recordList.length' [collectionSize]="totalRecords" [rotate]="true"
                                [maxSize]="5" [pageSize]="pageSize" [ellipses]="false" [boundaryLinks]="true"
                                [(page)]="currentPage"
                                (pageChange)="onPageChange($event)" class="float-right"></ngb-pagination>
            </div>
        </div>
        <!-- ADDING OR UPDATING RECORD FORMAT -->
        <div class="w-100 float-left" *ngIf='recordPage'>
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0" *ngIf="!isEdit">Add Record Format </h5>
                <h5 class="medium m-0" *ngIf="isEdit">Edit Record Format - {{recordData.recordFormatCode}}</h5>
                <div class="ml-alert"></div>
                <div style="flex-grow: 1;"></div>
                <button class="btn btn-secondary" (click)="onBack()">
                    <i class="fa fa-arrow-left mr-sm-2"></i> Back
                </button>

            </div>
            <div class="w-100 float-left mt-3">
                <div class='col-lg-6 col-md-6 float-left left-clear'>
                    <div class="form-group">
                        <label> Name
                            <span class="text-danger medium">*</span>
                        </label>
                        <input maxlength="200" type="text" class="form-control" [(ngModel)]="recordData.name"
                               name="name"
                               placeholder=" Record Format Name"/>
                    </div>
                </div>
                <div class='col-lg-6 col-md-6 float-left'>
                    <div class="form-group">
                        <label> Description
                            <span class="text-danger medium"></span>
                        </label>
                        <textarea maxlength="350" class="form-control" rows="1" [(ngModel)]="recordData.description"
                                  name="description" placeholder="Description (Optional)"></textarea>
                    </div>
                </div>
                <div class='col-lg-6 col-md-6 float-left left-clear'>
                    <div class="form-group">
                        <label> Display Name
                            <span class="text-danger medium">*</span>
                        </label>
                        <input maxlength="200" type="text" class="form-control" [(ngModel)]="recordData.displayName"
                               name="name" placeholder=" Display Name"/>
                    </div>
                </div>
                <div class='col-lg-6 col-md-6 float-left'>
                    <div class="form-group">
                        <label> Type
                            <span class="text-danger medium"></span>
                        </label>
                        <textarea maxlength="350" class="form-control" rows="1"
                                  [(ngModel)]="recordData.recordFormatType"
                                  name="description" placeholder="Type"></textarea>
                    </div>
                </div>
                <ng-container>
                    <div class="col-lg-6 col-md-6 float-left  left-clear">
                        <div class="form-group w-100 float-left">
                            <label for="dataSource">Data Source</label>
                            <select class="form-control light-bg" (change)='selectDataSource($event)'>
                                <option value='none'>None</option>
                                <option *ngFor="let dataSource of dataSourceList" [attr.value]='dataSource.id'
                                        [attr.selected]="recordData.dataSourceId == dataSource.id ? true : null">
                                    {{dataSource.name}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left my-4 form-group accordionss">
                        <!-- <ngb-accordion class="w-100">
                            <ngb-panel id="someId" title="Record Format Fields">
                                <ng-template ngbPanelContent> -->
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left my-4" *ngIf="isEdit">
                            <button class="btn btn-primary float-left" id="addRecordFields"
                                    (click)="addRecordFormatFields()">Add
                                Record Format Fields
                            </button>
                        </div>
                        <ng-container *ngIf='showField'>
                            <div [ngClass]="!isEdit ? 'col-lg-6 col-md-6  left-clear' : 'col-lg-6 col-md-6 float-left'">
                                <div class="form-group">
                                    <label> Field Name
                                        <span class="text-danger medium"></span>
                                    </label>
                                    <input maxlength="200" class="form-control" type="text" id="fieldName"
                                           maxlength="100"
                                           placeholder="Record Format Field Name"
                                           [(ngModel)]="recordFormatData.fieldName"/>
                                </div>
                            </div>
                            <div [ngClass]="!isEdit ? 'col-lg-6 col-md-6  left-clear' : 'col-lg-6 col-md-6 float-left'">
                                <div class="form-group">
                                    <label> Field Display Name
                                        <span class="text-danger medium"></span>
                                    </label>
                                    <input maxlength="200" class="form-control" type="text" id="fieldDisplayName"
                                           maxlength="100" placeholder="Record Format Field Display Name"
                                           [(ngModel)]="recordFormatData.displayName"/>
                                </div>
                            </div>
                            <div [ngClass]="!isEdit ? 'col-lg-6 col-md-6  left-clear' : 'col-lg-6 col-md-6 float-left'">
                                <div class="form-group">
                                    <label> Field Data Type
                                        <span class="text-danger medium"></span>
                                    </label>
                                    <select class="form-control light-bg" [(ngModel)]='recordFormatData.fieldDatatype'>
                                        <option value="STRING">STRING</option>
                                        <option value="DOUBLE">DOUBLE</option>
                                        <option value="DATE">DATE</option>
                                        <option value="DATETIME">DATE TIME</option>
                                        <option value="LONG">LONG</option>
                                    </select>
                                </div>
                            </div>
                            <div class='col-lg-6 col-md-6 float-left left'>
                                <div class="w-100 float-left">
                                    <p for="enableCache" class="mb-0 mr-3"> Is primary key</p>
                                    <input id="enableCache" type="checkbox" [(ngModel)]="recordFormatData.isPK">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left my-4">
                                <button class="btn btn-primary float-left" id="addField" (click)="addField()"> Add
                                </button>
                            </div>

                        </ng-container>
                        <div class="w-100 float-left mt-3"
                             *ngIf="recordFormatFieldData && recordFormatFieldData.length > 0 ">
                            <div class="light-bg w-100 float-left p-2 grid-details">
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Field Name">
                                    <h6 class="mb-lg-0 medium text-truncate"> Field Name </h6>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                     ngbTooltip="Field Display Name">
                                    <h6 class="mb-lg-0 medium text-truncate"> Field Display Name </h6>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left" ngbTooltip="Data Type">
                                    <h6 class="mb-lg-0 medium text-truncate"> Data Type </h6>
                                </div>
                                <!-- <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Data Format">
                                        <h6 class="mb-lg-0 medium text-truncate">Date Format </h6>
                                    </div> -->
                                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left" ngbTooltip="Is primary key">
                                    <h6 class="mb-lg-0 medium text-truncate"> Is primary key </h6>
                                </div>
                                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"
                                     ngbTooltip="Actions">
                                    <h6 class="mb-lg-0 medium text-truncate"> Actions </h6>
                                </div>
                            </div>
                        </div>
                        <div class="w-100 float-left p-md-2 grid-details"
                             *ngFor="let rff of recordFormatFieldData; let i = index">
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                <!-- <h6 class="mb-lg-0 text-truncate"> {{rff.fieldName}} </h6> -->
                                <input type="text" class="form-control border" id="fieldName" maxlength="100"
                                       [readonly]="!isFieldEdit[i]" [ngClass]="errorIndexF == i ? 'border-danger' : ''"
                                       [(ngModel)]="rff.fieldName" (blur)="onValidateEdit(rff,i)"/>
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                <!-- <h6 class="mb-lg-0 text-truncate"> {{rff.displayName}} </h6> -->
                                <input class="form-control border" type="text" id="fieldDisplayName" maxlength="100"
                                       [readonly]="!isFieldEdit[i]" [ngClass]="errorIndexD == i ? 'border-danger' : ''"
                                       [(ngModel)]="rff.displayName" (blur)="onValidateEdit(rff,i)"/>
                            </div>
                            <div *ngIf="!this.isFieldEdit[i]" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left">
                                <div class="form-control col-lg-4 float-left">
                                    <h6 class="mb-lg-0 text-truncate">
                                        {{rff.fieldDatatype | uppercase}} </h6>
                                </div>
                                <span class="pl-2 mb-lg-0 float-left"
                                      *ngIf="(rff.fieldDatatype == 'DATE' || rff.fieldDatatype == 'date' || rff.fieldDatatype == 'DATETIME') && rff.dateFormat"
                                      ngbTooltip="Date Format">
                                    <h6 class="form-control mb-lg-0 text-truncate">
                                        {{rff.dateFormat}} </h6>
                                </span>
                            </div>
                            <div *ngIf="this.isFieldEdit[i]" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left">
                                <div class="float-left">
                                    <select class="form-control light-bg mb-lg-0 text-truncate"
                                            [ngModel]="rff.fieldDatatype | uppercase"
                                            (ngModelChange)="setFieldDatatype($event,rff)">
                                        <option value="STRING">STRING</option>
                                        <option value="DOUBLE">DOUBLE</option>
                                        <option value="DATE">DATE</option>
                                        <option value="DATETIME">DATE TIME</option>
                                        <option value="TIMESTAMP">TIMESTAMP</option>
                                        <option value="LONG">LONG</option>
                                    </select>
                                </div>

                                <span class="float-left pl-2" *ngIf="this.isFieldEdit[i]" ngbTooltip="Date Format">
                                    <div *ngIf="(rff.fieldDatatype == 'DATE' || rff.fieldDatatype == 'date')">
                                        <select class="form-control light-bg" [(ngModel)]="rff.dateFormat">
                                            <option value="YYYY-MM-DD">YYYY-MM-DD</option>
                                            <option value="YYYY/MM/DD">YYYY/MM/DD</option>
                                            <option value="DD-MM-YYYY">DD-MM-YYYY</option>
                                            <option value="DD/MM/YYYY">DD/MM/YYYY</option>
                                            <option value="MM-DD-YY">MM-DD-YY</option>
                                            <option value="MM/DD/YY">MM/DD/YY</option>
                                            <option value="DATEVALUE">DATE VALUE</option>
                                        </select>
                                    </div>
                                    <div *ngIf="(rff.fieldDatatype == 'DATETIME')">
                                        <select class="form-control light-bg" [(ngModel)]="rff.dateFormat">
                                            <option value="YYYY-MM-DD HH:MM:SS">YYYY-MM-DD HH:MM:SS</option>
                                            <option value="YYYY/MM/DD HH:MM:SS">YYYY/MM/DD HH:MM:SS</option>
                                            <option value="DD-MM-YYYY HH:MM:SS">DD-MM-YYYY HH:MM:SS</option>
                                            <option value="DD/MM/YYYY HH:MM:SS">DD/MM/YYYY HH:MM:SS</option>
                                            <option value="MM-DD-YY HH:MM:SS">MM-DD-YY HH:MM:SS</option>
                                            <option value="MM/DD/YY HH:MM:SS">MM/DD/YY HH:MM:SS</option>
                                            <option value="DATETIMEVALUE">DATE TIME VALUE</option>
                                        </select>
                                    </div>
                                </span>
                            </div>
                            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                                <input class="float-left" #isPk type="checkbox" [(ngModel)]='rff.isPK'
                                       (change)="selectPrimaryKey(isPk.checked,rff.id)"/>
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center">
                                <h6 class="mb-lg-0 text-left">
                                    <i *ngIf="!valBu" class="fa fa-pencil mr-2" (click)="onEditPrevField(rff, i)"> Edit
                                    </i>
                                    <i class="fa fa-trash mr-2" (click)="onDeleteField($event, rff)"> Delete
                                    </i>
                                </h6>
                            </div>
                        </div>
                        <!-- </ng-template>
                            </ngb-panel>
                        </ngb-accordion> -->
                    </div>

                </ng-container>
                <div class="col-lg-2 col-md-2 float-right">
                    <button class="btn btn-primary float-right" [disabled]="saveButton" (click)="onSave()">Save</button>
                </div>
            </div>
        </div>
    </div>
    <div class="w-100 float-left min-h2 relative" *ngIf="loader">
        <loader></loader>
    </div>
</ng-container>


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/recordFormat.component.html